import { render, staticRenderFns } from "./tabHandle.vue?vue&type=template&id=769fd5cc&scoped=true&"
import script from "./tabHandle.vue?vue&type=script&lang=js&"
export * from "./tabHandle.vue?vue&type=script&lang=js&"
import style0 from "./tabHandle.vue?vue&type=style&index=0&id=769fd5cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769fd5cc",
  null
  
)

export default component.exports